<template>
  <v-container>
    <v-row>
      <div v-if="chart.isNullScore" class="pa-4 text-center">
        {{ emptyDataText }}
      </div>
      <v-col class="px-1 chart-container">
        <GChart
          type="PieChart"
          class="broker-score-chart"
          :data="chartData"
          :options="options"
          :settings="settings"
        />
        <div class="broker-score-chart-percentage">
          {{ chart.displayScore }}%
        </div>
        <div class="broker-score-chart-score-container">
          <div class="broker-chart-score">
            <div class="broker-score-chart-labels-font font-weight-light">
              0.00%
            </div>
            <div class="broker-score-chart-labels-font font-weight-light">
              {{ graphEndPercentTextLabel }}
            </div>
          </div>
          <div class="broker-score-type">{{ chart.type }}</div>
          <div>
            <ul class="legend pl-0">
              <li class="legend-list-item">
                <span
                  v-bind:class="[
                    'legend-square',
                    this.legendColorRed ? 'redLevelColor' : '',
                    this.legendColorBronze ? 'bronzeLevelColor' : '',
                    this.legendColorSilver ? 'silverLevelColor' : '',
                    this.legendColorGold ? 'goldLevelColor' : '',
                    this.legendColorPlatinum ? 'platinumLevelColor' : '',
                  ]"
                ></span>
                <span class="broker-score-legend-text font-weight-light pl-2">
                  {{ chart.legendText }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  name: "OverviewBrokerScoreChart",
  components: {
    GChart,
  },
  props: {
    chart: {
      type: Object,
      default: () => {
        return {
          percentage: null,
          type: "",
        };
      },
    },
  },
  computed: {
    legendColorRed() {
      return this.chart.color === "#AF322F";
    },
    legendColorBronze() {
      return this.chart.color === "#AD8A56";
    },
    legendColorSilver() {
      return this.chart.color === "#A9B1B3";
    },
    legendColorGold() {
      return this.chart.color === "#E3CD61";
    },
    legendColorPlatinum() {
      return this.chart.color === "#8F99A0";
    },
    graphEndPercentTextLabel() {
      // each graph will be labeled 0.00% on the left and 100.00% on the right
      // except for Conversion, which will be: if score is less than or equal to 10, the scale will be 0-10. If value is >10, then the scale will be 0-35.
      if (this.chart.type === "Conversion Performance") {
        if (this.chart.displayScore <= 10) {
          return "10.00%";
        } else if (
          this.chart.displayScore > 10 &&
          this.chart.displayScore <= 35
        ) {
          return "35.00%";
        } else {
          return "100.00%";
        }
      }
      return "100.00%";
    },
    chartData() {
      return [
        ["Scores", "Percentage"],
        ["", this.chartInc],
        ["", 100 - this.chartInc - 50], // fake a slice for gray color outline
        ["", 50], // invisible bottom portion of the pie chart
      ];
    },
  },
  data() {
    return {
      emptyDataText:
        "We’re sorry, there was not enough data to display the correct score",
      options: {
        width: 250,
        height: 250,
        enableInteractivity: false,
        legend: "none",
        pieSliceText: "none",
        pieHole: 0.7,
        pieStartAngle: -90,
        pieEndAngle: 180,
        tooltip: { trigger: "none" },
        animation: {
          startup: true,
          duration: 3000,
          easing: "out",
        },
        slices: {
          0: { color: this.chart.color },
          1: { color: "#E8E8E8" },
          2: { color: "transparent" },
        },
        chartArea: {
          top: 0,
          height: "100%",
          width: "100%",
        },
      },
      chartInc: 0,
      chartEnd: 0,
      animating: false,
      animationInterval: null,
      settings: { packages: ["corechart"] },
    };
  },
  methods: {
    startChartAnimation() {
      this.chartEnd = this.chart.percentage;
      if (this.chartEnd !== this.chartInc) {
        clearInterval(this.animationInterval);
        this.animationInterval = setInterval(this.animateChart, 5);
      } else {
        clearInterval(this.animationInterval);
      }
    },
    animateChart() {
      if (this.chartEnd !== this.chartInc) {
        this.animating = true;
        this.chartEnd > this.chartInc
          ? (this.chartInc += 1)
          : (this.chartInc -= 1);
      }

      if (this.chartEnd === this.chartInc) {
        clearInterval(this.animationInterval);
      }
    },
  },
  mounted() {
    console.log("Mounted score for type: " + this.chart.type);
    console.log("Passing score overall: " + this.chart.percentage);
    console.log("Passing score overall: " + this.chart.color);

    setTimeout(this.startChartAnimation, 300);
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
}
.broker-score-chart-labels-font {
  font-size: 12px;
}
.broker-score-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 250px;
  width: 250px;
  z-index: 1;
  transform: translate(-50%, -50%);
}
.referrals-metric-chart >>> div {
  /* center chart within rendered inner div */
  margin: 0 auto;
  z-index: 1;
}

.broker-score-chart-score-container {
  position: relative;
  top: 71%;
  left: 50%;
  height: 250px;
  width: 250px;
  z-index: 1;
  transform: translate(-50%, -50%);
}
.broker-chart-score {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.broker-score-chart-percentage {
  font-size: 40px;
  font-weight: bold;
  width: 200px;
  top: 35%;
  position: relative;
  z-index: 2;
  left: calc(50% - 100px);
  text-align: center;
}
.broker-score-type {
  font-size: 18px;
  max-width: 180px;
  text-align: center;
  color: #606060;
  margin: 10px auto 0 auto;
}
.broker-score-type {
  font-size: 18px;
  max-width: 250px;
  text-align: center;
  color: #606060;
  margin: 10px auto 0 auto;
}

/* basic positioning */
.legend {
  list-style: none;
}
/*.legend li {*/
/*  float: left;*/
/*  margin-right: 10px;*/
/*}*/

.legend .legend-list-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.legend .legend-square {
  border: 1px solid #e8e8e8;
  /*float: left;*/
  width: 20px;
  height: 20px;
  margin: 2px;
  border-radius: 5px;
}
/* chart legend colors */
.legend .redLevelColor {
  background-color: #af322f;
}
.legend .bronzeLevelColor {
  background-color: #ad8a56;
}
.legend .silverLevelColor {
  background-color: #a9b1b3;
}
.legend .goldLevelColor {
  background-color: #e3cd61;
}
.legend .platinumLevelColor {
  background-color: #8f99a0;
}
.broker-score-legend-text {
  white-space: nowrap;
  font-size: 14px !important;
}
</style>
